import React, { useEffect, useRef, useState } from "react";
import "./testimonials.css";
import { Data } from "./Data";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay, Keyboard } from "swiper/modules";

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);

  // subtle reveal on scroll
  useEffect(() => {
    const el = document.querySelector("#testimonial .testimonial__containerWrap");
    if (!el) return;

    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && el.classList.add("is-visible")),
      { threshold: 0.15 }
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  const total = Data.length;

  return (
    <section className="testimonial section" id="testimonial">
      <div className="testimonial__wrapper container">
        <h2 className="section__title">Testimonials</h2>
        <span className="section__subtitle">What clients say after working with me</span>

        <div className="testimonial__topBar">
          <div className="testimonial__meta">
            <span className="testimonial__count">
              <strong>{activeIndex + 1}</strong> / {total}
            </span>
            <span className="testimonial__hint">Swipe, use arrows, or click a dot</span>
          </div>

          <div className="testimonial__controls">
            <button
              type="button"
              className="tBtn"
              onClick={() => swiperRef.current?.slidePrev()}
              aria-label="Previous testimonial"
            >
              <i className="uil uil-arrow-left"></i>
            </button>
            <button
              type="button"
              className="tBtn"
              onClick={() => swiperRef.current?.slideNext()}
              aria-label="Next testimonial"
            >
              <i className="uil uil-arrow-right"></i>
            </button>
          </div>
        </div>

        <div className="testimonial__containerWrap">
          <Swiper
            className="testimonial__container mySwiper"
            loop={true}
            grabCursor={true}
            spaceBetween={18}
            speed={650}
            autoplay={{
              delay: 4200,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            keyboard={{ enabled: true }}
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 2 },
              768: { slidesPerView: 2, spaceBetween: 28 },
              1024: { slidesPerView: 3, spaceBetween: 28 },
            }}
            modules={[Pagination, Autoplay, Keyboard]}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
              setActiveIndex(swiper.realIndex ?? 0);
            }}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex ?? 0)}
          >
            {Data.map(({ id, image, title, description, role, company, rating }) => (
              <SwiperSlide className="testimonial__card" key={id}>
                <div className="testimonial__cardInner">
                  <div className="testimonial__head">
                    <div className="testimonial__profile">
                      <img src={image} alt={title} className="testimonial__img" />
                      <div className="testimonial__who">
                        <h3 className="testimonial__name">{title}</h3>

                        {(role || company) && (
                          <p className="testimonial__role">
                            {role ? role : "Client"}
                            {company ? ` • ${company}` : ""}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="testimonial__badge" aria-hidden="true">
                      <i className="uil uil-quote-right"></i>
                    </div>
                  </div>

                  {typeof rating === "number" && (
                    <div className="testimonial__rating" aria-label={`Rating: ${rating} out of 5`}>
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i key={i} className={`uil ${i < rating ? "uil-star" : "uil-star"}`}></i>
                      ))}
                    </div>
                  )}

                  <p className="testimonial__description">{description}</p>

                  <div className="testimonial__footer">
                    <span className="testimonial__pill">
                      <i className="uil uil-check-circle"></i> Verified feedback
                    </span>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
